import { APP_INITIALIZER, Provider } from '@angular/core';
import { countriesInitializer } from './countries-initializer';

export const provideCountries = (): Provider => ({
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: countriesInitializer,
});
